import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import {
  CustomersByFailedPayment,
  DbTransactionsInfo,
  FailedStripeTransactions,
  ICharge,
  IGetAllChargesListResponseData,
} from "../../api/charges/index.types";

export interface IDayChargesState {
  data: {
    transactions: ICharge[];
    dbTransactionsInfo: DbTransactionsInfo[];
    failedStripeTransactions: FailedStripeTransactions[];
    customersByFailedPayment: CustomersByFailedPayment[];
    transactionsByEmail: ICharge[];
  };
  loading: boolean;
}

const initialState: IDayChargesState = {
  data: {
    transactions: [],
    dbTransactionsInfo: [],
    failedStripeTransactions: [],
    customersByFailedPayment: [],
    transactionsByEmail: [],
  },
  loading: false,
};

const index = createSlice({
  name: "charges",
  initialState,
  reducers: {
    fetchChargesRequest: (state) => {
      state.loading = true;
    },
    fetchChargesSuccess: (state, action: PayloadAction<IGetAllChargesListResponseData>) => {
      state.loading = false;
      state.data = action.payload;
    },
    fetchChargesFailed: (state) => {
      state.loading = false;
    },
    clearCharges: (state) => {
      state.data = {
        transactions: [],
        dbTransactionsInfo: [],
        failedStripeTransactions: [],
        customersByFailedPayment: [],
        transactionsByEmail: [],
      };
    },
  },
});

export const chargesActions = index.actions;
export default index.reducer;
